import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrintTplManifestComponent } from './manifest/manifest.component';

@NgModule({
    declarations: [
        PrintTplManifestComponent
    ],
    exports: [
        PrintTplManifestComponent
    ],
    imports: [
        TranslateModule.forChild(),
        CommonModule
    ]
})
export class PrintTemplateModule {
}
